"use client";

import { useState } from "react";
import Link from "next/link";

const faqs = [
  {
    question: "What is kratom?",
    answer:
      "Kratom (Mitragyna speciosa) is a tropical tree native to Southeast Asia. The leaves contain natural alkaloids and have been used traditionally for centuries. Kratom is sold as a dietary supplement in the United States.",
  },
  {
    question: "What are Red, White, and Green lines?",
    answer:
      "The color refers to the vein color of the kratom leaf at harvest. Red vein is typically associated with evening use, white with morning energy, and green as an all-day balance. Our three lines — Grounded, Focused, and Balanced — reflect these traditional profiles.",
  },
  {
    question: "How do I choose?",
    answer:
      "If you're new, we recommend starting with our Green Line (Balanced) — it's the most versatile. Order includes a free sample so you can try before committing to a full kilo.",
  },
  {
    question: "Is it tested?",
    answer:
      "Every Kratapillar batch is third-party lab tested by Cascadia Labs. We publish full Certificates of Analysis on our Lab Testing page.",
  },
];

export default function NewToKratomSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section
      className="py-24 border-t"
      style={{ borderColor: "#E0DFDB", backgroundColor: "#F6F5F2" }}
    >
      <div className="max-w-container mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20">
          {/* Left: Heading */}
          <div className="lg:col-span-4">
            <span className="section-label mb-4 block">Education</span>
            <h2
              className="font-serif font-bold mb-4"
              style={{
                fontFamily: "Fraunces, Georgia, serif",
                fontSize: "clamp(2rem, 3.5vw, 3rem)",
                letterSpacing: "-0.03em",
                lineHeight: "1.05",
                color: "#1F1F1F",
              }}
            >
              New to
              <br />
              <em style={{ color: "#3F5A45" }}>Kratom?</em>
            </h2>
            <p
              className="text-base leading-relaxed mb-6"
              style={{ color: "#6B6B6B", fontFamily: "Inter, system-ui, sans-serif" }}
            >
              Everything you need to know before your first order.
            </p>
            <Link
              href="/faq"
              className="inline-flex items-center gap-2 text-sm font-semibold"
              style={{ color: "#3F5A45", fontFamily: "Inter, system-ui, sans-serif" }}
            >
              Full FAQ
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                <path d="M5 12H19M13 6L19 12L13 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </Link>
          </div>

          {/* Right: FAQ items */}
          <div className="lg:col-span-8">
            <div className="space-y-0">
              {faqs?.map((faq, i) => (
                <div
                  key={i}
                  className="border-b"
                  style={{ borderColor: "#E0DFDB" }}
                >
                  <button
                    onClick={() => setOpenIndex(openIndex === i ? null : i)}
                    className="w-full flex items-center justify-between py-5 text-left"
                  >
                    <span
                      className="text-base font-semibold pr-6"
                      style={{ color: "#1F1F1F", fontFamily: "Inter, system-ui, sans-serif" }}
                    >
                      {faq?.question}
                    </span>
                    <span
                      className="flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-full transition-transform"
                      style={{
                        backgroundColor: openIndex === i ? "#3F5A45" : "transparent",
                        border: `1px solid ${openIndex === i ? "#3F5A45" : "#E0DFDB"}`,
                        transform: openIndex === i ? "rotate(45deg)" : "rotate(0deg)",
                        transition: "all 0.25s ease",
                      }}
                    >
                      <svg width="10" height="10" viewBox="0 0 24 24" fill="none">
                        <path
                          d="M12 5v14M5 12h14"
                          stroke={openIndex === i ? "white" : "#6B6B6B"}
                          strokeWidth="2.5"
                          strokeLinecap="round"
                        />
                      </svg>
                    </span>
                  </button>
                  {openIndex === i && (
                    <div
                      className="pb-5 text-sm leading-relaxed"
                      style={{ color: "#6B6B6B", fontFamily: "Inter, system-ui, sans-serif" }}
                    >
                      {faq?.answer}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
